import { createIcon } from '@chakra-ui/icons';

export const HamburgerDragHandle = createIcon({
  displayName: 'HamburgerDragHandle',
  viewBox: '0 0 12 12',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M11.5 6.49902H0.5C0.2 6.49902 0 6.29902 0 5.99902C0 5.69902 0.2 5.49902 0.5 5.49902H11.5C11.8 5.49902 12 5.69902 12 5.99902C12 6.29902 11.8 6.49902 11.5 6.49902Z"
        fill="currentColor"
      />
      <path
        d="M11.5 2.99902H0.5C0.2 2.99902 0 2.79902 0 2.49902C0 2.19902 0.2 1.99902 0.5 1.99902H11.5C11.8 1.99902 12 2.19902 12 2.49902C12 2.79902 11.8 2.99902 11.5 2.99902Z"
        fill="currentColor"
      />
      <path
        d="M11.5 9.99902H0.5C0.2 9.99902 0 9.79902 0 9.49902C0 9.19902 0.2 8.99902 0.5 8.99902H11.5C11.8 8.99902 12 9.19902 12 9.49902C12 9.79902 11.8 9.99902 11.5 9.99902Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
